import React from 'react';
import { MessageCircleIcon, InstagramIcon, MailIcon } from 'lucide-react';
const contacts = [{
  icon: MessageCircleIcon,
  label: 'WhatsApp',
  value: '+54 9 223 651 4354',
  href: 'https://wa.me/5492236514354'
}, {
  icon: InstagramIcon,
  label: 'Instagram',
  value: '@pdagency.mkt',
  href: 'https://www.instagram.com/pdagency.mkt/'
}, {
  icon: MailIcon,
  label: 'Email',
  value: 'webs24hs@gmail.com',
  href: 'mailto:webs24hs@gmail.com'
}];
export function Footer() {
  return <footer className="w-full bg-brand-ink py-14 text-white" data-id="element-72" data-mp="37o5ytxdtvcu">
      <div className="mx-auto w-full max-w-6xl px-5 sm:px-8" data-id="element-73" data-mp="3lec94e8vg8fv">
        <div className="flex flex-col gap-10 md:flex-row md:items-start md:justify-between" data-id="element-74" data-mp="3ldu8l5f6f825">
          <div className="max-w-xs" data-id="element-75" data-mp="3qbvoxil7wt9x">
            <div className="flex items-center gap-2" data-id="element-76" data-mp="29z6t68jqcdeb">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-brand-yellow text-sm font-extrabold text-brand-ink" data-id="element-77" data-mp="29ydrvn3jig3k">
                24
              </span>
              <span className="text-lg font-extrabold tracking-tight" data-id="element-78" data-mp="3l8qy89n2utu3">WEB24HS</span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-white/50" data-id="element-79" data-mp="3gbingu49ds2v">
              Páginas web profesionales con dominio propio, entregadas en 24 horas.
            </p>
          </div>

          <ul className="grid gap-4 sm:grid-cols-3 md:gap-10" data-id="element-80" data-mp="3q83q58st2r3j">
            {contacts.map(contact => <li key={contact.label} data-id="element-81" data-mp="828mq5huy395">
                <a href={contact.href} target={contact.href.startsWith('mailto:') ? undefined : '_blank'} rel={contact.href.startsWith('mailto:') ? undefined : 'noopener noreferrer'} className="group flex items-center gap-3 text-sm text-white/70 transition-colors hover:text-brand-yellow" data-id="element-82" data-mp="81785r1muymo">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-white/10 transition-colors group-hover:bg-brand-yellow group-hover:text-brand-ink" data-id="element-83" data-mp="qub5bme27tm1">
                    <contact.icon className="h-4 w-4" aria-hidden="true" data-id="element-84" data-mp="tvw84i1avhgi" />
                  </span>
                  <span className="font-semibold leading-tight" data-id="element-85" data-mp="ytekkiej0et9">
                    {contact.label}
                    <span className="block text-xs font-normal text-white/40" data-id="element-86" data-mp="13s9as5etp5ne">{contact.value}</span>
                  </span>
                </a>
              </li>)}
          </ul>
        </div>

        <div className="mt-12 border-t border-white/10 pt-6" data-id="element-87" data-mp="1ckkp4swnx2n0">
          <p className="text-xs text-white/40" data-id="element-88" data-mp="1hkp94sws4fhz">© 2026 WEB24HS. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>;
}